export const NON_EDITABLE_PENDING_FIELD_MESSAGES = {
  minor_owns_non_custodial_account:
    "Minors can't be owners on non-custodial accounts. Update the date of birth, or remove this person from the account's Owners section.",
  custodial_owners_both_minor:
    "A custodial account must have one minor and one adult custodian, but both owners are minors. Update an owner's date of birth, or change the owners so one is an adult custodian.",
  custodial_owner_no_minor:
    "A custodial account must have a minor owner, but neither owner is a minor. Update an owner's date of birth, or change the owners so one is a minor.",
};

export const isNonEditablePendingField = (key) =>
  Object.prototype.hasOwnProperty.call(NON_EDITABLE_PENDING_FIELD_MESSAGES, key);
